import WorkoutsPreLeaveModal from './WorkoutsPreLeaveModal';

export default WorkoutsPreLeaveModal;
